import {
  WEBSOCKET_BROKEN,
  WEBSOCKET_CLOSED,
  WEBSOCKET_CONNECT,
  WEBSOCKET_DISCONNECT,
  WEBSOCKET_OPEN,
  WEBSOCKET_SEND,
  DEFAULT_PREFIX,
} from '@giantmachines/redux-websocket';

const websocketReducer = (state = {}, action) => {
  switch (action.type) {
    case `${DEFAULT_PREFIX}::${WEBSOCKET_CONNECT}`:
    case `${DEFAULT_PREFIX}::${WEBSOCKET_CLOSED}`:
    case `${DEFAULT_PREFIX}::${WEBSOCKET_DISCONNECT}`:
    case `${DEFAULT_PREFIX}::${WEBSOCKET_BROKEN}`:
    case `${DEFAULT_PREFIX}::${WEBSOCKET_SEND}`:
      return state;
    case `${DEFAULT_PREFIX}::${WEBSOCKET_OPEN}`:
      return state;
    default:
      return state;
  }
};

export default websocketReducer;
